import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const exportOrderToPDF = async (orderData, items) => {
  const pdf = new jsPDF();
  
  // Set up the document
  pdf.setFontSize(20);
  pdf.text('JR Web - Order Summary', 20, 20);
  
  // Order information
  pdf.setFontSize(12);
  pdf.text(`Order Date: ${new Date().toLocaleDateString()}`, 20, 40);
  pdf.text(`Customer: ${orderData.firstName} ${orderData.lastName}`, 20, 50);
  pdf.text(`Email: ${orderData.email}`, 20, 60);
  pdf.text(`Phone: ${orderData.phone}`, 20, 70);
  
  // Shipping address
  pdf.setFontSize(14);
  pdf.text('Shipping Address:', 20, 90);
  pdf.setFontSize(12);
  pdf.text(`${orderData.address}`, 20, 100);
  pdf.text(`${orderData.city}, ${orderData.state} ${orderData.zipCode}`, 20, 110);
  pdf.text(`${orderData.country}`, 20, 120);
  
  // Order items
  pdf.setFontSize(14);
  pdf.text('Order Items:', 20, 140);
  
  let yPosition = 155;
  pdf.setFontSize(10);
  
  // Table headers
  pdf.text('Item', 20, yPosition);
  pdf.text('Qty', 100, yPosition);
  pdf.text('Price', 130, yPosition);
  pdf.text('Total', 160, yPosition);
  
  yPosition += 10;
  pdf.line(20, yPosition, 190, yPosition); // Draw line
  yPosition += 10;
  
  let subtotal = 0;
  
  items.forEach((item) => {
    const itemTotal = item.price * item.quantity;
    subtotal += itemTotal;
    
    pdf.text(item.name.substring(0, 30), 20, yPosition);
    pdf.text(item.quantity.toString(), 100, yPosition);
    pdf.text(`$${item.price.toFixed(2)}`, 130, yPosition);
    pdf.text(`$${itemTotal.toFixed(2)}`, 160, yPosition);
    
    yPosition += 10;
    
    // Add new page if needed
    if (yPosition > 270) {
      pdf.addPage();
      yPosition = 20;
    }
  });
  
  // Order summary
  yPosition += 10;
  pdf.line(20, yPosition, 190, yPosition);
  yPosition += 15;
  
  const shipping = subtotal > 50 ? 0 : 9.99;
  const tax = subtotal * 0.08;
  const total = subtotal + shipping + tax;
  
  pdf.setFontSize(12);
  pdf.text(`Subtotal: $${subtotal.toFixed(2)}`, 130, yPosition);
  pdf.text(`Shipping: ${shipping === 0 ? 'FREE' : `$${shipping.toFixed(2)}`}`, 130, yPosition + 10);
  pdf.text(`Tax: $${tax.toFixed(2)}`, 130, yPosition + 20);
  
  pdf.setFontSize(14);
  pdf.text(`Total: $${total.toFixed(2)}`, 130, yPosition + 35);
  
  // Payment method
  yPosition += 50;
  pdf.setFontSize(12);
  pdf.text(`Payment Method: ${orderData.paymentMethod === 'card' ? 'Credit Card' : 'PayPal'}`, 20, yPosition);
  
  // Footer
  pdf.setFontSize(10);
  pdf.text('Thank you for shopping with JR Web!', 20, 280);
  pdf.text('Questions? Contact us at support@jrweb.com', 20, 290);
  
  // Save the PDF
  pdf.save(`JR-Web-Order-${new Date().getTime()}.pdf`);
};

export const exportReceiptElement = async (elementId, filename = 'receipt.pdf') => {
  const element = document.getElementById(elementId);
  if (!element) {
    console.error('Element not found');
    return;
  }
  
  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true
    });
    
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
    const imgWidth = 210;
    const pageHeight = 295;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    
    let position = 0;
    
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
    
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    pdf.save(filename);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};